import * as ReactDOM from "react-dom";
import * as React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { searchStateReducer } from "../slice/search-slice";
import { combineReducers, compose, createStore } from "redux";
import { AppState } from "../model/state-models";
import { Provider } from "react-redux";
import { MenuApp } from "./menu-app";
import Navbar from "./component/header";
import Footer from "./component/footer";
import Home from "./component/home";

const entry = document.getElementById("app-entry");

export const stateReducer = combineReducers<AppState<any>>({
  searchState: searchStateReducer,
});

const composeEnhancer =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const stateStore = createStore(stateReducer, composeEnhancer());

if (entry) {
  ReactDOM.render(
    <Provider store={stateStore}>
      <BrowserRouter>
        <Navbar />
        <Switch>
          <Route exact path="/" render={() => <Home />} />
          <Route exact path="/menu" render={() => <MenuApp app={"Ryo Sushi"} />} />
          <Route exact path="/contact-us" render={() => <>Contact Us</>} />
          <Route exact path="/about-us" render={() => <>About Us</>} />
          <Route path="*" render={() => <>Error</>} />
        </Switch>
        <Footer />
      </BrowserRouter>
    </Provider>,
    entry
  );
}
